import {
    PriceLike,
    SalesforceProductPrice,
    SalesforceProductPriceType,
    SalesforceProductPromotionType,
} from '~/lib/salesforce/types';

export const hasPromotionType = (
    prices: SalesforceProductPrice[] | undefined,
    promotionType: SalesforceProductPromotionType,
): boolean => !!prices?.some((price) => price.promotype === promotionType);

/**
 * Derive promo type from price labels and splash text as fallback check for `hasPromotionType` if there is no promo type.
 */
export const derivePromoType = ({
    promoType,
    splash,
    prices,
}: {
    promoType?: string;
    splash?: { text?: string };
    prices: PriceLike[];
}): SalesforceProductPromotionType | null => {
    if (promoType) return promoType.toLowerCase() as SalesforceProductPromotionType;

    const label = prices
        ?.find((price) => price.type === SalesforceProductPriceType.DEFAULT)
        ?.label?.toLowerCase();
    const splashText = splash?.text?.toLowerCase();

    if (label?.includes('superpris') || splashText?.includes('superpris')) {
        return SalesforceProductPromotionType.SUPER_PRICE;
    }

    if (label?.includes('julepris') || splashText?.includes('julepris')) {
        return SalesforceProductPromotionType.CHRISTMAS_PRICE;
    }

    return null;
};
